import { zCorpCompanySummaryDom, zCorpTariffSummaryDom, } from "@/types/corp/corpCompany.domain";
import { zCorpCompanySummaryRowDto, zCorpTariffRowDto } from "@/types/corp/corpCompany.dto";
/** BR-SET-08: лимит исчерпан, когда баланс отрицательнее лимита. */
const computeCreditState = (balance, creditLimit) => balance < -creditLimit ? "LIMIT_EXHAUSTED" : "OK";
/** BR-2 (UC1130): баннеры считаются на клиенте — `corp_my_companies` не отдаёт `credit_state`/итогов (Q-D). */
const computeBanners = (row) => {
    const banners = [];
    if (row.status === "SUSPENDED")
        banners.push("SUSPENDED");
    if (row.creditState === "LIMIT_EXHAUSTED")
        banners.push("LIMIT");
    if (row.overdueInvoicesCount > 0)
        banners.push("OVERDUE");
    if (row.status === "ARCHIVED")
        banners.push("ARCHIVED");
    return banners;
};
export const CorpCompanyMapper = {
    /** Строка `corp_my_companies` (§4.4). */
    summaryToDomain(raw) {
        const row = zCorpCompanySummaryRowDto.parse(raw);
        const creditState = computeCreditState(row.balance, row.credit_limit);
        const banners = computeBanners({
            status: row.status,
            creditState,
            overdueInvoicesCount: row.overdue_invoices_count,
        });
        return zCorpCompanySummaryDom.parse({
            companyId: row.company_id,
            name: row.name,
            legalName: row.legal_name ?? null,
            inn: row.inn ?? null,
            status: row.status,
            creditLimit: row.credit_limit,
            balance: row.balance,
            availableCredit: row.available_credit,
            overdueAmount: row.overdue_amount,
            overdueInvoicesCount: row.overdue_invoices_count,
            openOrdersCount: row.open_orders_count,
            openOrdersExposure: row.open_orders_exposure,
            billingPeriod: row.billing_period,
            invoiceIssueDay: row.invoice_issue_day,
            paymentTermDays: row.payment_term_days,
            creditState,
            banners,
        });
    },
    /** Строка `corp_my_tariff` (§4.4). */
    tariffToDomain(raw) {
        const row = zCorpTariffRowDto.parse(raw);
        return zCorpTariffSummaryDom.parse({
            companyId: row.company_id,
            idAdvance: row.id_advance,
            name: row.name,
            advancePricePerKwh: row.advance_price_per_kwh,
            advanceOneTimeFee: row.advance_one_time_fee,
            latePricePerKwh: row.late_price_per_kwh,
            lateOneTimeFee: row.late_one_time_fee,
            cutoffHourMsk: row.cutoff_hour_msk,
            cutoffOffsetDays: row.cutoff_offset_days,
        });
    },
};
